import {
    navigateWithAttribution,
    withAttributionPassthrough
} from '../composables/attributionNavigation.js';

export default {
    name: 'CheckoutMixin',
    props: ['websiteUrl', 'fitter'],
    data() {
        return {
            customOptions: {
                type: 'lightbox',
                inject: 'onload',
                iframeIntegrationId: 'libraryObject',
                iframeHelperURL: this.websiteUrl +  '/helper.html',
                iframeBaseURL: this.websiteUrl,
                target: 'payment-fancybox',
                trigger: 'payment-submit',
                accessibility: true,
                debug: false,
                language: 'en',
                country: 'gb',
                preferredPaymentMethod: 'VISA-SSL',
                successURL: this.websiteUrl +'/order-processing',
                cancelURL: this.websiteUrl +'/booking-details',
                failureURL: this.websiteUrl +'/order-failure',
                pendingURL: this.websiteUrl +'/order-pending',
                errorURL: this.websiteUrl +'/error'
            },
            formData: new FormData(),
            updatedBasket: this.basket,
            serviceData: [],
            fitterServices: this.fitter.services ?? [],
            registration: this.sessionReg != null ? this.sessionReg : '',
            postcode: this.sessionPostcode != null ? this.sessionPostcode : '',
            serviceModalOpen: false,
            billingAddresses: this.addresses,
            shippingAddresses: this.addresses,
            inputAddressManually: false,
            inputShippingAddressManually: false,
            //Shipping fields,
            same_as_billing: (this.basket?.home_delivery == 1 || this.fitter?.mobile == 1) ? true : false,
            //Order fields
            agreed_conditions: false,
            paymentMethod: 'card',
            validateAppDate: this.basket?.home_delivery == 0,
            validateAppTime: (this.basket?.home_delivery == 0 && (this.fitter?.mobile == 0 || this.fitter?.cal_account_number == 'CALTOTD')),
            customerData: {}
        };
    },
    mounted() {
        this.emitter.on('refreshBasket', data => {
            this.refreshBasket();
        });

        this.emitter.on('updateBasket', data => {
            this.updatedBasket = data;
        });

        this.emitter.on('refreshServices', data => {
            this.refreshServices(data);
        });

        // DEBUG: force ServiceModal open on page load to inspect content/events.
        // Set to false (or remove this block) before shipping.
        const debugOpenServiceModalOnLoad = false;
        if (debugOpenServiceModalOnLoad) {
            this.debugOpenServiceModal();
        }
    },
    methods: {
        debugOpenServiceModal() {
            axios.post('/ajax/service_modal_window')
                .then(response => {
                    this.serviceData = response.data.services ?? [];
                    this.serviceModalOpen = true;
                    console.log('[debug] ServiceModal force-opened on load', {
                        show_modal: response.data.show_modal,
                        services: this.serviceData,
                        response: response.data,
                    });
                })
                .catch(error => {
                    console.error('[debug] Failed to load ServiceModal data', error);
                    // Still open with empty services so layout can be inspected
                    this.serviceData = this.serviceData?.length ? this.serviceData : (this.fitterServices ?? []);
                    this.serviceModalOpen = true;
                });
        },
        isPostOrderUpsellRoute() {
            const route = this.updatedBasket?.route ?? this.basket?.route ?? '';

            return typeof route === 'string' && route.startsWith('upsell-');
        },
        onCheckoutSubmit(values, actions) {
            this.emitter.emit('isLoading', true);

            //Track Upsell modal opening
            if(typeof(this.$gtag) !== 'undefined') {
                this.$gtag.event('checkout_submit', {
                    'event_category' : 'Checkout',
                    'event_label' : 'Complete Order Button Clicked'
                });
            }
            else {
                console.log('gtag not loaded');
            }

            let vm = this;
            vm.formActions = actions; // capture vee-validate actions for server-side error mapping
            //Loop through posted values and append to formData
            Object.entries(values).forEach(([key, param]) => {

                if (key === 'address' && vm.inputAddressManually === true) {
                    return;
                }

                if (key === 'shipping_address' && vm.inputShippingAddressManually === true) {
                    return;
                }

                //Changed check, as this was omitting any fields that were not truthy in nature.
                if (param !== undefined) {
                    vm.formData.append(key, param);
                }
            });

            //Store values for later use with Squeezely tracking.. <(^.^)>
            vm.customerData.email = values.email;
            vm.customerData.firstname = values.forename;
            vm.customerData.lastname = values.surname;
            vm.customerData.phone = values.telephone;
            vm.customerData.postcode = values.postcode;

            //Store values for later use with Squeezely tracking.. <(^.^)>
            vm.customerData.email = values.email;
            vm.customerData.firstname = values.forename;
            vm.customerData.lastname = values.surname;
            vm.customerData.phone = values.telephone;
            vm.customerData.postcode = values.postcode;

            vm.formData.append('same_as_billing', (this.same_as_billing == true ? 1 : 0));

            if (this.isPostOrderUpsellRoute()) {
                const basket = this.updatedBasket ?? this.basket ?? {};
                const upsellFields = {
                    email: basket.email,
                    title: basket.billing_title,
                    forename: basket.billing_forename,
                    surname: basket.billing_surname,
                    address1: basket.billing_address1,
                    address2: basket.billing_address2,
                    address3: basket.billing_address3,
                    town: basket.billing_town,
                    county: basket.billing_county,
                    postcode: basket.billing_postcode,
                    telephone: basket.billing_telephone,
                    registration: basket.registration,
                    shipping_title: basket.shipping_title,
                    shipping_forename: basket.shipping_forename,
                    shipping_surname: basket.shipping_surname,
                    shipping_address1: basket.shipping_address1,
                    shipping_address2: basket.shipping_address2,
                    shipping_address3: basket.shipping_address3,
                    shipping_town: basket.shipping_town,
                    shipping_county: basket.shipping_county,
                    shipping_postcode: basket.shipping_postcode,
                    shipping_telephone: basket.shipping_telephone,
                    app_date: basket.app_date,
                    app_time: basket.app_time,
                };

                Object.entries(upsellFields).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== '') {
                        vm.formData.append(key, value);
                    }
                });

                this.processOrder();
                return;
            }

            if(this.updatedBasket.home_delivery == false) {
                //Check for services to upsell to customer
                axios.post('/ajax/service_modal_window')
                .then(response => {
                    //Check that the returned service should launch a modal, and that this service isn't already in the basket
                    if(response.data.show_modal && vm.serviceInBasket == false) {
                        this.emitter.emit('isLoading', false);

                        vm.serviceData = response.data.services ?? [];
                        vm.serviceModalOpen = true;

                        //Track Upsell modal opening
                        if(typeof(vm.$gtag) !== 'undefined') {
                            vm.$gtag.event('service_modal', {
                                'event_category' : 'Checkout',
                                'event_label' : 'Service Modal Opened'
                            });
                        }
                        else {
                            console.log('gtag not loaded');
                        }

                        return;
                    }
                    //No services to upsell found, proceed to payment
                    else {
                        this.processOrder();
                    }
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            }
            else {
                this.processOrder();
            }
        },
        handleServiceUpsell(serviceCode, quantity, skipDeclineTracking = false) {
            let vm = this;
            const acceptedUpsell = serviceCode != null && typeof serviceCode !== 'undefined' && serviceCode !== '';

            if (acceptedUpsell) {
                var basketFormData = new FormData();
                basketFormData.append('st_code', serviceCode);
                basketFormData.append('quantity', quantity);

                axios.post('/ajax/add_to_basket', basketFormData)
                .then(response => {
                    if(response.data.basket_updated == true)
                    {
                        vm.updatedBasket = response.data.basket;
                        this.processOrder();
                    }
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            }
            else {
                if (!skipDeclineTracking) {
                    const gtag = vm.$gtag ?? vm.$parent?.$gtag

                    if (typeof gtag !== 'undefined') {
                        gtag.event('service_modal', {
                            'event_category': 'Checkout',
                            'event_label': 'Service Modal Upsell Declined'
                        });
                    }
                    else {
                        console.log('gtag not loaded');
                    }
                }

                this.processOrder();
            }

            vm.serviceModalOpen = false;
        },
        processOrder: function() {
            //Toggle global loading component
            this.emitter.emit('isLoading', true);

            let vm = this;
            axios.post('/ajax/process_order', vm.formData)
            .then(response => {
                //Toggle global loading component
                this.emitter.emit('isLoading', false);

                if(response.data.success == true)
                {
                    //Track Upsell modal opening
                    if(typeof(vm.$gtag) !== 'undefined') {
                        vm.$gtag.event('payment_form_open', {
                            'event_category' : 'Payment',
                            'event_label' : 'Payment Modal Opened'
                        });
                    }
                    else {
                        console.log('gtag not loaded');
                    }

                    /* Squeezely PrePurchase */
                    this.emitter.emit('updateSqueezely', {
                        "event" : "PrePurchase",
                        "email" : vm.customerData.email,
                        "firstname" : vm.customerData.firstname,
                        "lastname" : vm.customerData.lastname,
                        "phone" : vm.customerData.telephone,
                        "postcode" : vm.customerData.postcode,
                        "currency" : "GBP",
                        "language" : "en-GB",
                        "products" : vm.stCodes
                    });

                    if (typeof response.data.full_page_redirect != 'undefined' && response.data.full_page_redirect == true)
                    {
                        void navigateWithAttribution(response.data.url);
                    }
                    else
                    {
                        vm.initializeHostedPaymentPageContent(response.data.url);
                    }
                }
                else
                {
                    if(typeof response.data.redirect != 'undefined') {
                        void navigateWithAttribution(response.data.redirect, { replace: true });
                        return;
                    }

                    // If backend returned field-level errors as an object, surface inline via Vee-Validate
                    if (response.data && response.data.errors && typeof response.data.errors === 'object')
                    {
                        if (vm.formActions && typeof vm.formActions.setFieldError === 'function')
                        {
                            Object.keys(response.data.errors).forEach((field) => {
                                const message = response.data.errors[field];
                                vm.formActions.setFieldError(field, Array.isArray(message) ? message[0] : message);
                            });

                            // Focus first invalid field for accessibility
                            const firstField = Object.keys(response.data.errors)[0];
                            const el = document.getElementsByName(firstField);
                            if (el && el[0] && typeof el[0].focus === 'function')
                            {
                                el[0].focus();
                            }
                        }
                        else
                        {
                            // Fallback to alert if actions are not available
                            alert('There are errors in your details. Please review highlighted fields.');
                        }
                    }
                    else
                    {
                        const message = (typeof response.data.errors === 'string') ? response.data.errors : 'An unknown error has occurred.';
                        alert(message);
                    }
                }
            })
            .catch(error => {
                console.error("There was an error!", error);
            });
        },
        initializeHostedPaymentPageContent: function(payment_url)
        {
            this.customOptions.url = payment_url;
            this.customOptions.successURL = withAttributionPassthrough(this.websiteUrl + '/order-processing');
            this.customOptions.cancelURL = withAttributionPassthrough(this.websiteUrl + '/booking-details');
            this.customOptions.failureURL = withAttributionPassthrough(this.websiteUrl + '/order-failure');
            this.customOptions.pendingURL = withAttributionPassthrough(this.websiteUrl + '/order-pending');
            this.customOptions.errorURL = withAttributionPassthrough(this.websiteUrl + '/error');

            var libraryObject = new WPCL.Library();

            libraryObject.setup(this.customOptions);

            dispatchEvent(new CustomEvent('load'));

            this.$refs.paymentSubmit.click();
        },
        refreshBasket(updatedPostcode = null) {
            let vm = this;
            // If updatedPostcode is not provided, backend will fallback to session postcode
            axios.get('/ajax/get_basket/1', {
                params: {
                    updated_postcode: updatedPostcode
                }
            })
            .then(response => {
                if (typeof(response.data.basket) != 'undefined') {
                    vm.updatedBasket = response.data.basket;
                }
            })
            .catch(error => {
                console.error("There was an error!", error);
            });
        },
        refreshServices(services) {
            this.fitterServices['available'] = services['available'];
            this.fitterServices['unavailable'] = services['unavailable'];
        },
        async updateDeliveryCharges(postcode) {
            const cleanPostcode = postcode.trim();

            if (!cleanPostcode) {
                console.error('❌ No postcode provided for delivery charge update');
                return false;
            }

            this.emitter.emit('deliveryChargeUpdating', {
                status: true,
                postcode: cleanPostcode
            });

            try {
                const response = await axios.get(`/ajax/update_delivery_charges/${cleanPostcode}`);

                // Check if we have a valid response structure
                if (!response.data) {
                    console.warn('⚠️ Invalid response from server.');
                    return false;
                }

                if (response.data.success) {
                    // Successfully updated delivery charges
                    await this.refreshBasket(cleanPostcode); // Update basket with new charges
                    this.emitter.emit('deliveryChargeUpdating', {
                        status: false,
                        postcode: cleanPostcode
                    });

                    return true;
                } else {
                    this.emitter.emit('deliveryChargeUpdating', {
                        status: false,
                        postcode: cleanPostcode
                    });
                    // Handle case where success is false
                    console.warn('⚠️ Failed to update delivery charges. Please try again after verifying your postcode.');
                    return false;
                }
            } catch (error) {
                this.emitter.emit('deliveryChargeUpdating', {
                    status: false,
                    postcode: cleanPostcode
                });

                console.warn('⚠️ Could not update delivery charges. Please try again after verifying your postcode.');
                return false;
            }
        },
        async postcodeLookup(postcode, billing = false) {
            // Input validation
            if (!postcode?.trim()) {
                console.log('No postcode provided');
                return;
            }

            const cleanPostcode = postcode.trim();
            if (cleanPostcode.length < 3) {
                console.log('Postcode too short (minimum 3 characters):', cleanPostcode);
                return;
            }

            try {
                // Fetch addresses & set update session only if billing is true
                const { data } = await axios.get(`/ajax/postcode_addresses/${cleanPostcode}/${billing == true ? true : false}`);

                if (!data?.response) {
                    console.log('No addresses found for postcode:', cleanPostcode);
                    return;
                }

                // Update appropriate address list
                if (billing) {
                    this.billingAddresses = data.response;

                    // If "same as billing" is checked, billing address is also the delivery address
                    // So we need to update delivery charges
                    if (this.same_as_billing && this.isValidUKPostcode(cleanPostcode)) {
                        try {
                            await this.updateDeliveryCharges(cleanPostcode);
                        } catch (deliveryError) {
                            console.error('Failed to update delivery charges:', deliveryError.message);
                        }
                    }
                } else {
                    this.shippingAddresses = data.response;

                    // Check for valid UK postcode format before updating delivery charges
                    if (this.isValidUKPostcode(cleanPostcode)) {
                        console.log('Valid UK postcode detected:', cleanPostcode);
                        try {
                            await this.updateDeliveryCharges(cleanPostcode);
                        } catch (deliveryError) {
                            console.error('Failed to update delivery charges:', deliveryError.message);
                        }
                    }
                }
            } catch (error) {
                console.error('Postcode lookup failed.');
            }
        }
    },
    watch: {
        same_as_billing: {
            async handler(newValue) {
                if (newValue === true) {
                    // When checking "same as billing", use billing postcode for delivery
                    const billingPostcodeInput = document.querySelector('input[name="postcode"]');
                    const billingPostcode = billingPostcodeInput?.value || '';

                    if (billingPostcode && this.isValidUKPostcode(billingPostcode)) {
                        // First update session with billing postcode via postcodeLookup
                        await this.postcodeLookup(billingPostcode, true);
                        // Then update delivery charges with the billing postcode
                        await this.updateDeliveryCharges(billingPostcode);
                    } else {
                        console.warn('⚠️ No valid billing postcode found when toggling same-as-billing');
                    }
                } else {
                    // When unchecking "same as billing", use shipping postcode for delivery
                    const shippingPostcodeInput = document.querySelector('input[name="shipping_postcode"]');
                    const shippingPostcode = shippingPostcodeInput?.value || '';

                    if (shippingPostcode && this.isValidUKPostcode(shippingPostcode)) {
                        // Update session with shipping postcode and recalculate delivery
                        await this.postcodeLookup(shippingPostcode, false);
                        // Note: postcodeLookup with billing=false already calls updateDeliveryCharges
                    } else {
                        console.warn('⚠️ No valid shipping postcode found when unchecking same-as-billing');
                    }
                }
            }
        }
    },
    computed: {
        /**
         * Validates if a string matches UK postcode format
         * @param {string} postcode - The postcode to validate
         * @returns {boolean} - True if postcode is valid
         */
        isValidUKPostcode() {
            return (postcode) => {
                const ukPostcodeRegex = /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i;
                return ukPostcodeRegex.test(postcode.trim().toUpperCase());
            };
        },
        serviceInBasket() {
            const services = Array.isArray(this.serviceData) ? this.serviceData : (this.serviceData ? [this.serviceData] : []);

            if (services.length === 0 || this.updatedBasket.products.length === 0) {
                return false;
            }

            const serviceCodes = services.map(service => service.code);

            return this.updatedBasket.products.some(basketProduct => serviceCodes.includes(basketProduct.st_code));
        },
        stCodes() {
            let stCodes = [];
            let product;

            if(this.updatedBasket.products.length > 0) {
                this.updatedBasket.products.forEach(function (basketProduct) {
                    product = {
                        'id': basketProduct.st_code
                    };
                    stCodes.push(product);
                });
            }

            return stCodes;
        }
    }
};
